import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Header from './components/Header'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Home from './pages/Home'
import Courses from './pages/Courses'
import MyEnrollments from './pages/MyEnrollments'
import MyGrades from './pages/MyGrades'
import Certificate from './pages/Certificate'
import Profile from './pages/Profile'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminNotices from './pages/admin/AdminNotices'
import AdminSemesters from './pages/admin/AdminSemesters'
import AdminCourseCreate from './pages/admin/AdminCourseCreate'
import AdminCourseList from './pages/admin/AdminCourseList'
import AdminEnrollments from './pages/admin/AdminEnrollments'
import AdminGrades from './pages/admin/AdminGrades'
import AdminCompletions from './pages/admin/AdminCompletions'
import AdminLegacyCompletions from './pages/admin/AdminLegacyCompletions'
import AdminStatistics from './pages/admin/AdminStatistics'
import AdminUsers from './pages/admin/AdminUsers'
import Enroll from './pages/Enroll'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route 
              path="/enroll/:id" 
              element={
                <ProtectedRoute>
                  <Enroll />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-enrollments" 
              element={
                <ProtectedRoute>
                  <MyEnrollments />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-grades" 
              element={
                <ProtectedRoute>
                  <MyGrades />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/certificate" 
              element={
                <ProtectedRoute>
                  <Certificate />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/notices" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminNotices />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/semesters" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminSemesters />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/courses/create" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminCourseCreate />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/courses/list" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminCourseList />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/enrollments" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminEnrollments />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/grades" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminGrades />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/completions" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminCompletions />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/legacy-completions" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminLegacyCompletions />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/users" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminUsers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/statistics" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminStatistics />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
